/**
 * Onboarding tour state management with Zustand
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface OnboardingState {
  isFirstVisit: boolean;
  tourCompleted: boolean;
  currentStep: number;
  showTour: boolean;
  tourSkippedAt: string | null;
  tourCompletedAt: string | null;

  // Actions
  startTour: () => void;
  skipTour: () => void;
  nextStep: () => void;
  prevStep: () => void;
  completeTour: () => void;
  resetTour: () => void;
  setCurrentStep: (step: number) => void;
}

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set, get) => ({
      isFirstVisit: true,
      tourCompleted: false,
      currentStep: 0,
      showTour: false,
      tourSkippedAt: null,
      tourCompletedAt: null,

      startTour: () => {
        set({
          showTour: true,
          currentStep: 0,
          isFirstVisit: false,
        });
      },

      skipTour: () => {
        set({
          showTour: false,
          tourSkippedAt: new Date().toISOString(),
        });
      },

      nextStep: () => {
        const { currentStep } = get();
        set({ currentStep: currentStep + 1 });
      },

      prevStep: () => {
        const { currentStep } = get();
        if (currentStep > 0) {
          set({ currentStep: currentStep - 1 });
        }
      },

      completeTour: () => {
        set({
          showTour: false,
          tourCompleted: true,
          tourCompletedAt: new Date().toISOString(),
        });
      },

      resetTour: () => {
        set({
          currentStep: 0,
          showTour: true,
          isFirstVisit: false,
        });
      },

      setCurrentStep: (step: number) => {
        set({ currentStep: step });
      },
    }),
    {
      name: 'onboarding-storage',
      partialize: (state) => ({
        isFirstVisit: state.isFirstVisit,
        tourCompleted: state.tourCompleted,
        tourSkippedAt: state.tourSkippedAt,
        tourCompletedAt: state.tourCompletedAt,
      }),
    }
  )
);
